import React, {useContext, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import axios from "@common/axios";
import {UserContext} from "@context/UserContext";
import Switch from "@common/Switch";
import ListItemCore from "@common/ListItemCore";
import {BrandContext} from "@context/BrandContext";

const NavDocumentItem = props => {
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {documentId, className, classId, meta, url, enabled = true, disabled = false, active = false, visible, children} = props;


    const handleClickDocument = (event) => {
        if(disabled || documentId == undefined) {
            return;
        }

        openMediaDocument(documentId);
    };

    return (
        <li className={'ch-list-item' + (active ? ' ch-list-item-active' : '') + (className ? ' ' + className : '') + (disabled && !active ? ' ch-list-item-disabled' : '')}>
            <a onClick={handleClickDocument}>
                <ListItemCore meta={meta}>
                    {children}
                </ListItemCore>
            </a>
        </li>
    )
}


export default NavDocumentItem;